module.exports = __webpack_public_path__ + "img/916.75f09490.png";